// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__tkD-I","colBig":"styles_colBig__1Yg0e","colSmall":"styles_colSmall__1uOoj"};